import * as Cookies from 'cookies-next';

export const parse = async (fallbackValue?: boolean) => {
  // To set this cookie value in browser:
  // 1. Open the browser's Javascript console
  // 2. Type/Paste in:
  //    * `document.cookie = "__tally_health_override_omit_phone_number=true"`
  //    * `document.cookie = "__tally_health_override_omit_phone_number=false"`
  // 3. Press enter
  return Cookies.getCookie('__tally_health_override_omit_phone_number') === true;
};
